'use client';
import React from "react";
import Router from "next/router";
import { useTranslator } from "../../i18n";

import Home from "./Home";
import Don from "./Don";
import Paiement from "./Paiement";
import Horaires from "./Horaires";
import JewishZmanim from "./JewishZmanim";
import Shabbat from "./Shabbat";
import Services from "./Services";
import Abonnements from "./Abonnements";
import Events from "./Events";
import Event from "./Event";
import Galeries from "./Galeries";
import GalerieImages from "./GalerieImages";
import Actu from "./Actu";
import ActuDetail from "./ActuDetail";
import CustomPage from "./CustomPage";
import FormPage from "./Form";
import Article from "./Article";
import ContentHub from "./ContentHub";
import AccountSpacePage from "./AccountSpacePage";
import EncheresPage from "./EncheresPage";
import Page404 from "./404";
import LinkMetaRender from "./LinkMetaRender";

import ThemeVars from "./ThemeVars";
import ThemeRoot from "./ThemeRoot";

// Contexte propagé à tous les composants du thème 2026.
export const Theme2026Context = React.createContext({});

export default function Theme2026({ context }) {
    const [loading, setLoading] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(context.isMobile);
    const [isIframe, setIsIframe] = React.useState(false);

    React.useEffect(() => {
        setIsIframe(window.self !== window.top);

        const ro = new ResizeObserver(() => {
            setIsMobile(document.body.offsetWidth <= 768);
        });
        ro.observe(document.body);

        const start = () => setLoading(true);
        const end = () => setLoading(false);
        Router.events.on("routeChangeStart", start);
        Router.events.on("routeChangeComplete", end);
        Router.events.on("routeChangeError", end);

        return () => {
            ro.disconnect();
            Router.events.off("routeChangeStart", start);
            Router.events.off("routeChangeComplete", end);
            Router.events.off("routeChangeError", end);
        };
    }, []);

    const page = context.page;
    const T = useTranslator(context);
    const _context = { ...context, isMobile, isIframe, T };

    let Component;
    switch (page.type) {
        case "HOME":             Component = Home; break;
        case "PAIEMENT":         Component = Paiement; break;
        case "DON":              Component = Don; break;
        case "HORAIRES":         Component = Horaires; break;
        case "JEWISH_ZMANIM":    Component = JewishZmanim; break;
        case "SHABBAT":          Component = Shabbat; break;
        case "SERVICES":         Component = Services; break;
        case "ABONNEMENTS":      Component = Abonnements; break;
        case "EVENTS":           Component = Events; break;
        case "EVENT":            Component = Event; break;
        case "GALERIES":         Component = Galeries; break;
        case "GALERIES_IMAGES":  Component = GalerieImages; break;
        case "ACTU":             Component = Actu; break;
        case "ACTU_DETAIL":      Component = ActuDetail; break;
        case "CUSTOM_PAGE":      Component = CustomPage; break;
        case "FORM":             Component = FormPage; break;
        case "LINK":             Component = LinkMetaRender; break;
        case "ARTICLE":          Component = Article; break;
        case "CONTENT_HUB":      Component = ContentHub; break;
        case "ACCOUNT":          Component = AccountSpacePage; break;
        case "ENCHERES":
        case "ENCHERES_VENTE":   Component = EncheresPage; break;
        case "404":              Component = Page404; break;
        default:                 Component = Page404; break;
    }

    return (
        <Theme2026Context.Provider value={_context}>
            <ThemeVars config={context.config} />
            <ThemeRoot context={_context}>
                <Component context={_context} loading={loading} />
            </ThemeRoot>
        </Theme2026Context.Provider>
    );
}
